'use client'

import { cn } from '@/utilities/ui'
import { quicksand } from '@/utilities/fontImport'
import { useState, type ChangeEventHandler } from 'react'
import Eye from '../icons/eye'
import EyeOff from '../icons/eye-off'

export const Input = ({
  label,
  id,
  name,
  type = 'text',
  defaultValue,
  value,
  onChange,
  placeholder,
  required = false,
  readOnly = false,
  disabled = false,
  className,
}: {
  label?: string
  id?: string
  name: string
  type?: string
  defaultValue?: string
  value?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  placeholder?: string
  required?: boolean
  readOnly?: boolean
  disabled?: boolean
  className?: string
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const inputId = id ?? name
  const isPassword = type === 'password'
  const isLocked = disabled || readOnly

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label htmlFor={inputId} className={cn('font-bold text-primary pl-1', quicksand.className)}>
          {label}
        </label>
      )}
      <div className={cn('rounded-full', isLocked ? 'border border-light-pink' : 'gradient-border')}>
        <div className="relative flex items-center">
          <input
            id={inputId}
            name={name}
            type={isPassword && showPassword ? 'text' : type}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            readOnly={readOnly}
            disabled={disabled}
            className={cn(
              'w-full rounded-full border-0 py-2 px-4 font-semibold placeholder:text-primary/60 focus-visible:ring-secondary/50 focus-visible:ring-offset-0',
              isLocked ? 'bg-transparent text-primary/50' : 'bg-pink-200 text-primary',
              isPassword && 'pr-10',
            )}
          />
          {isPassword && (
            <button
              type="button"
              onClick={() => setShowPassword((value) => !value)}
              className="absolute right-3 text-primary/50"
              tabIndex={-1}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
